/** micro-US$ → "US$ 0,0123"; null = preço do modelo desconhecido */
export const usd = (micro: number | null) => (micro === null ? '—' : `US$ ${(micro / 1_000_000).toLocaleString('pt-BR', { minimumFractionDigits: 4, maximumFractionDigits: 4 })}`);
